<template>
	<!-- ===== background full-viewport ===== -->
	<div
		class="min-h-screen bg-no-repeat bg-center md:bg-right bg-cover relative flex items-center justify-start px-6"
		:style="{ backgroundImage: `url(${bg})` }"
	>
		<!-- overlay -->
		<div class="absolute inset-0 bg-black/60"></div>

		<!-- ===== form “card” ===== -->
		<form
			@submit.prevent="reset"
			class="relative z-10 w-full max-w-sm mx-auto space-y-4 p-8 rounded shadow bg-white/10 backdrop-blur text-gray-900"
		>
			<h2 class="text-xl font-semibold text-white">Nuova password</h2>

			<input
				v-model="pwd1"
				type="password"
				placeholder="Nuova password"
				required
				class="w-full border border-gray-300 px-3 py-2 rounded"
			/>
			<input
				v-model="pwd2"
				type="password"
				placeholder="Conferma password"
				required
				class="w-full border border-gray-300 px-3 py-2 rounded"
			/>

			<p
				v-if="pwd2 && !match"
				class="text-red-400 text-sm"
			>
				* Le password non coincidono
			</p>

			<button
				:disabled="!match || loading"
				class="w-full bg-teal-600 hover:bg-teal-700 text-white py-2 rounded disabled:opacity-50 disabled:pointer-events-none"
			>
				Aggiorna password
			</button>
		</form>
	</div>
</template>

<script setup>
	import { ref, computed } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import axios from "@/axiosInstance";
	import { useToast } from "vue-toast-notification";

	const bg = require("@/assets/sfondo-bg-1.png"); // immagine

	/* route & token -------------------------------------------------------- */
	const route = useRoute();
	const router = useRouter();
	const token = route.query.token ?? "";
	if (!token) router.replace("/auth"); // token mancante → login

	/* stato form ----------------------------------------------------------- */
	const pwd1 = ref("");
	const pwd2 = ref("");
	const loading = ref(false);
	const match = computed(() => pwd1.value && pwd1.value === pwd2.value);
	const toast = useToast();

	/* submit --------------------------------------------------------------- */
	async function reset() {
		if (!match.value || loading.value) return;
		loading.value = true;
		try {
			await axios.post(`/auth/reset-password?token=${token}`, {
				password: pwd1.value,
			});
			toast.success("Password aggiornata – ora puoi effettuare il login", {
				position: "top-right",
				timeout: 5000,
			});
			router.replace("/auth");
		} catch (e) {
			toast.error(e.response?.data?.details || "Token non valido o scaduto", { position: "top-right", timeout: 5000 });
		} finally {
			loading.value = false;
		}
	}
</script>
